import { useCallback, useMemo, useState } from 'react';
import { UseStateful } from './useStateful';

export type UseNumericInput = UseStateful<number> & {
  onChange: (e: React.SyntheticEvent) => void;
  resetValue: () => void;
  eventBind: {
    onChange: (e: React.SyntheticEvent) => void;
    value: number;
  };
  valueBind: {
    onChange: React.Dispatch<number>;
    value: number;
  };
};

export const useNumericInput = (initial = 0): UseNumericInput => {
  const [value, setValue] = useState(initial);

  const onChange = useCallback((e) => setValue(Number(e.target.value)), []);
  const resetValue = useCallback(() => setValue(initial), []);

  return useMemo(
    () => ({
      value,
      setValue,
      resetValue,
      onChange,
      eventBind: {
        onChange,
        value,
      },
      valueBind: {
        onChange: setValue,
        value,
      },
    }),
    [resetValue, onChange, value]
  );
};

export default useNumericInput;
